import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { tap } from 'rxjs';
import { PlateformeLMSService } from 'src/app/modules/plateforme-lms/services/plateforme-lms.service';
import { ProgrammeCoursera } from 'src/app/model/programme-coursera';

import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { VcnRoutes } from '../../../vcn-routes.constants';
import { co } from '@fullcalendar/core/internal-common';
import { MentoratService } from 'src/app/modules/mentorat/services/mentorat.service';
@Component({
  selector: 'app-side-bar-apprenant',
  templateUrl: './side-bar-apprenant.component.html',
  styleUrls: ['./side-bar-apprenant.component.css'],
  animations: [
    trigger('slideToggle', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SideBarAprennantComponent {
  user: any | null;
  profil: any;
  logged: any;
  role!: any;
  cohorte!: string;
  nomrole!: string;
  parcours3: string = 'SIG2412-FODE';
  parcours4: string = 'SIG2502-FODE';
  parcours5: string = 'SIG2505-FODE';
  eleve: boolean = false;
  coursera_user: boolean = false;
  certificateOffackList: any[] = [];

  urlScholarVox = 'https://skills.scholarvox.com/forcen';
  urlProgramme: string = '';
  urlPpp: string = 'https://formation.force-n.sn/course/view.php?id=620';
  isOffTrackStudent: boolean = false;
  urlSoftSkills: string =
    'https://formation.force-n.sn/course/view.php?id=1239';
  urlFondAmorcage: string = 'https://fa.force-n.sn/auth/login/keycloak';

  urlClasseVirtuelle: string =
    'https://formation.force-n.sn/mod/bigbluebuttonbn/view.php?id=43470';
  hidden: boolean = false;
  isAdmin: boolean = false;
  isBoard: boolean = false;
  isSEV: boolean = false;
  isStemd: boolean = false;
  isStudentStemd: boolean = false;
  isMentor: boolean = false;
  isChefEtab: boolean = false;
  isFinance: boolean = false;
  isAipen: boolean = false;
  isAdminFcc: boolean = false;
  isAmi: boolean = false;
  isVCN: boolean = false;
  isPersonalCompany: boolean = false;
  isInCohort: boolean = false;

  sections = [
    { id: 1, isCollapsed: true },
    { id: 2, isCollapsed: true },
    { id: 3, isCollapsed: true },
    { id: 4, isCollapsed: true },
  ];
  vcnRoute = VcnRoutes;
  iuf: any;

  progClasseA: string =
    'https://www.coursera.org/career-academy/programs/career-academy-campus-learning-program-836mn?authMode=login&authProvider=universite-numerique-cheikh-hamidou-kane';
  progClasseB: string =
    'https://www.coursera.org/career-academy/programs/alumni-career-academy-learning-program-0tynr?authMode=login&authProvider=universite-numerique-cheikh-hamidou-kane';

  userObject: any;
  certificateOffTrackList: any[] = [];
  hasMae: boolean = false;
  isBenin: boolean = false;
  isSigCohorte: boolean = false;
  showIframe = false;

  constructor(
    private router: Router,
    private plateformeLMSService: PlateformeLMSService,
    public mentoratservice: MentoratService,
  ) {
    this.user = sessionStorage.getItem('user');
  }

  ngOnInit() {
    console.log('HI IM IN SIDEBAR APPRENANT');
    //console.log('USER:', JSON.parse(this.user));

    this.user = sessionStorage.getItem('user');
    console.log('USER:', JSON.parse(this.user));

    this.getIsinchorte(JSON.parse(this.user).iuf);
    this.logged = sessionStorage.getItem('logged');
    this.profil = JSON.parse(this.user).profile.id;
    this.iuf = JSON.parse(this.user).iuf;

    this.role = JSON.parse(this.user)?.roles;
    console.log('roles sidebar apprenant: 1 ', this.role);
    this.cohorte = JSON.parse(
      this.user,
    )?.beneficiaryCohortes[0]?.cohorte?.cohorteName;

    this.isSigCohorte = JSON.parse(this.user)
      ?.beneficiaryCohortes
      ?.some((bc: any) => bc?.cohorte?.cohorteName?.startsWith('SIG')) ?? false;
    this.userObject = JSON.parse(this.user);
    console.table('user object : ', this.userObject);
    this.certificateOffTrackList = this.userObject.offTrackList || [];
    this.hasMae = this.certificateOffTrackList.some(
      (item: any) => item.certification === 'MAE',
    );

    console.log('certificateOffTrackList', this.certificateOffTrackList);

    this.isBenin = this.certificateOffTrackList.some(
      (item: any) => item?.cohort?.includes('BENIN') ?? false,
    );

    console.log('Hase benin', this.isBenin);

    console.log('Hase MA', this.hasMae);
    if (this.role.length > 0) {
      console.log('this.role sidebar apprenants test', this.role);
      this.role.forEach((element: { id: number; roleName: any }) => {
        this.nomrole = element.roleName;
        sessionStorage.setItem('nomrole', this.nomrole);
        switch (element.roleName) {
          case 'admin': {
            this.isAdmin = true;
            break;
          }
          case 'eleve': {
            this.eleve = true;
            break;
          }

          case 'coursera_srudent': {
            this.coursera_user = true;
            this.initCourseraObservable(this.iuf);
            break;
          }

          case 'stemd': {
            this.isStemd = true;
            break;
          }
          case 'board': {
            this.isBoard = true;
            break;
          }
          case 'suivi': {
            this.isSEV = true;
            break;
          }
          case 'finance': {
            this.isFinance = true;
            break;
          }
          case 'etudiant_stemd': {
            this.isStudentStemd = true;
            break;
          }
          case 'chefetablissement_stemd': {
            this.isChefEtab = true;
            break;
          }
          case 'personal-company': {
            this.isPersonalCompany = true;
            break;
          }
          case 'mentor': {
            this.isMentor = true;
            break;
          }
          case 'aipen': {
            this.isAipen = true;
            break;
          }
          case 'admin-fcc': {
            this.isAdminFcc = true;
            break;
          }
          case 'ami': {
            this.isAmi = true;
          }
        }
      });
      // console.log(
      //   "le profil de l'apprenant xxxxxx : ",
      //   this.profil
      // );
    }
    if (JSON.parse(this.user)?.offTrackList.length > 0) {
      // console.log(
      //   'is hors parcours: ',
      //   JSON.parse(this.user)?.offTrackList.length
      // );
      this.isOffTrackStudent = true;
    }
    if (JSON.parse(this.user)?.citizenNumericVacationList.length > 0) {
      this.isVCN = true;
    }

    // console.log('user role: ', this.user);
  }
  reloadComponent(self: boolean, urlToNavigateTo?: string) {
    //skipLocationChange:true means dont update the url to / when navigating
    const url = self ? this.router.url : urlToNavigateTo;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        // console.log(`After navigation I am on:${this.router.url}`);
      });
    });
  }
  sessionChange(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidatures/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidatures/' + cohorte);
    }, 500);
  }
  openUrl(url: string) {
    window.open(url, '_blank');
  }

  toggleCollapse(id: number): void {
    const section = this.sections.find((sec) => sec.id === id);
    if (section) {
      section.isCollapsed = !section.isCollapsed;
    }
  }
  initCourseraObservable(iuf: string) {
    this.plateformeLMSService
      .getCourseraByIUF(iuf)
      .pipe(
        tap((coursera) => {
          // console.log('coursera :', coursera);
          if (coursera != null) {
            //check first access
            if (!coursera.firstAccess) {
              this.plateformeLMSService
                .checkFirstAccess(this.iuf)
                .pipe(
                  tap((check) => {
                    // console.log('status firstAccess: ', check);
                  }),
                )
                .subscribe();
            }
            if (
              coursera.programmeCoursera === ProgrammeCoursera.PROGR_CLASSE_A
            ) {
              this.urlProgramme = this.progClasseA;
              // console.log('url : ', this.urlProgramme);
            } else if (
              coursera.programmeCoursera === ProgrammeCoursera.PROGR_CLASSE_B
            ) {
              this.urlProgramme = this.progClasseB;
              // console.log('url : ', this.urlProgramme);
            }
          }
        }),
      )
      .subscribe();
  }
  getIsinchorte(iuf: any) {
    console.log(iuf);
    this.mentoratservice.getBeneficiaryinCohort(iuf).subscribe({
      next: (data) => {
        console.log(data);
        this.isInCohort = data;
      },
      error: (error) => {
        alert('erreur lors de la récuperation des données');
        console.log(error);
      },
    });
  }
}
